import React from "react";

export default function arrowLeft({ color = "#d7d9dd", strokeWidth = "5px", ...restProps }) {
  return (
    <svg
      id="arrow-left"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 216 216"
      width={216}
      height={216}
      {...restProps}
    >
      <polyline
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={strokeWidth}
        points="119.25 131.5 107.23 117.62 95.22 103.75 107.23 89.87 119.25 76"
      />
    </svg>
  );
}
